import "react-toggle/style.css"

// syntax highlighting theme
import "prism-themes/themes/prism-dracula.css"

import "./src/styles/global.css"
import "./src/styles/fonts.css"
